import { useContext } from 'react';
import { DataProvider } from './data-provider';

export const useData = () => {
  const context = useContext(DataProvider.DataContext);

  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }

  return context;
};
